<!-- Contrato Disponivel -->
<div class="timeline-badge">
    <a><em class="fa fa-circle"></em></a>
</div>

<h4 *ngIf="timelineActive">{{ timeline.dataHora | date:'HH:mm'}} <small>{{ timeline.dataHora | date:'dd/MM/yyyy'}}</small></h4>

<div class="timeline-panel" [ngClass]="{'timeline-panel-disabled': !timelineActive}">

    <div class="step">
        <span class="icon"></span>
        <h2>{{ timeline.tituloStatus }}</h2>
        <span>{{ timeline.subTituloStatus}}</span>

        <div *ngIf="timelineActive" class="specifications icon-stats">
            <div class="col-xs-12">
                <span class="icon wait"></span>
                <span class="stats">
                    <small>{{ timeline.cardDireito[0].valor }}</small>
                    {{ timeline.cardDireito[1].valor }}
                </span>
            </div>
        </div>

        <div *ngIf="!timelineActive"><br /></div>

    </div>

</div>
